export const BILLING_BLOCKED_PREFIXES = ["/dash/", "/records/"];
export const BILLING_BLOCKED_PATHS = new Set(["/available-modules", "/sync-all", "/facts/rebuild-scope"]);

export function shouldBlockProtectedRequest(url, guard = {}) {
  const pathOnly = String(url || "").split("?")[0];
  if (String(guard?.role || "").toLowerCase() === "super") return false;
  if (!guard?.locked) return false;
  if (BILLING_BLOCKED_PATHS.has(pathOnly)) return true;
  return BILLING_BLOCKED_PREFIXES.some((prefix) => pathOnly.startsWith(prefix));
}
